import React, { useEffect, useState } from "react";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import Typography from "@mui/material/Typography";
import { Grid } from "@mui/material";
import { FormLabel, TextField } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { useMaterialUIController } from "context";
import { call } from "services/axiosService/core";
import * as Sentry from "@sentry/browser";
import { useTranslation } from "react-i18next";
import { setProfile } from "context";

export default function Coupon({
  setAmountToProcess,
  setProceedtoPayment,
  childDetails,
  handleClosePaymentModal,
  setSessionExpired,
  setCouponUsed,
  subscriptionType,
}) {
  const { t } = useTranslation();
  const [controller] = useMaterialUIController();
  const { profile } = controller;
  const [referralCode, setReferralCode] = useState("");
  const [codeApplied, setCodeApplied] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [helperText, setHelperText] = useState("");
  const [showHelperText, setShowHelperText] = useState(false);
  const [amount, setAmount] = useState(null);
  const [paymentNotRequired, setPaymentNotRequired] = useState(false);
  const [demoUser, setDemoUser] = useState(false);
  useEffect(() => {
    const referral = localStorage.getItem("referral");
    if (referral) {
      setReferralCode(referral);
      verifyCouponHandler(referral);
    }
    else {
      const renewalCode = childDetails.referral_code || null;
      if (renewalCode && renewalCode.length > 0) {
        setReferralCode(renewalCode);
        verifyCouponHandler(renewalCode);
      }
    }
  }, []);

  const verifyCouponHandler = (code) => {
    setIsLoading(true);
    let data = { code: code, subscription_type: subscriptionType, learner_email: childDetails.email };
    call(`payments/verify-coupon`, "POST", { body: data })
      .then((response) => {
        if (response.status == 200) {
          if (parseFloat(response.data.amount_to_process) > 0) {
            setHelperText(
              t("alerts.referrals.couponApplied", { amount: response.data.amount_to_process })
            );
          } else {
            if (response.data.is_demo_user) {
              setDemoUser(true);
              setHelperText(t("alerts.referrals.noPaymentRequired"));
            } else {
              setPaymentNotRequired(true);
              setHelperText(t("alerts.referrals.noPaymentRequired"));
            }
          }
          setCodeApplied(true);
          setShowHelperText(true);
          setAmount(response.data.amount_to_process);
          setCouponUsed(code);
        } else if (response.status == 404 || response.status == 403) {
          setHelperText(t("alerts.referrals.notValid"));
          setShowHelperText(true);
          setAmount(null);
          setCouponUsed(null);
        } else if (response.status == 440) {
          setSessionExpired(true);
        }
        setIsLoading(false);
      })
      .catch(function (error) {
        Sentry.captureException(error);
        setIsLoading(false);
        setAmount(null);
        setCouponUsed(null);
        setHelperText(t("alerts.referrals.error"));
        setShowHelperText(true);
        console.log(error);
      });

    setIsLoading(true);
  };

  const RemoveCouponHandler = () => {
    setPaymentNotRequired(false);
    setCodeApplied(false);
    setDemoUser(false);
    console.log("subscription type", subscriptionType);
    if (subscriptionType == "true_mindsets_monthly") {
      setAmount(45);
    } else if (subscriptionType == "true_mindsets_yearly") {
      setAmount(480);
    } else {
      setAmount(99);
    }
    setShowHelperText(false);
    setPaymentNotRequired(false);
    setHelperText(t("alerts.referrals.removeCoupon"));
    setCouponUsed(null);
  };

  const proceedToPaymentHandler = () => {
    if (demoUser || paymentNotRequired) {
      let LearnerDetails = childDetails;
      const source =
      LearnerDetails.source ||
      (referralCode && referralCode.includes("_") ? `${referralCode.split("_")[0]}_code` : null);
      LearnerDetails = {
        ...LearnerDetails,
        source: source,
        payment_status: "success",
        paid_at: new Date(),
        is_demo_user: demoUser,
        referral_code: referralCode,
        subscription_type: subscriptionType,
      };
      // Update the coupon - Descrease coupon remaing usage count and add user email adress to coupon uses object
      call(`payments/apply-coupon`, "PUT", { body: { email: LearnerDetails.email, code: referralCode } })
        .then((response) => {
          console.log("coupon used");
        })
        .catch(function (error) {
          Sentry.captureException(error);
          console.log(error);
        });

      call(`users/${LearnerDetails.id}`, "PUT", {
        body: LearnerDetails,
        headers: { "Content-Type": "application/json" },
      })
        .then((response) => {
          if (response.status == 200) {
            const shouldAdd = !demoUser;
            handleClosePaymentModal("PaymentNotRequired", shouldAdd);
          }
        })
        .catch(function (error) {
          Sentry.captureException(error);
          console.log(error);
        });
      // if the added user is demouser and parent is not demouser, update parent as demouser
      if (LearnerDetails.id != profile.id && profile.is_demo_user == false && demoUser == true) {
        profile.is_demo_user = true;
        call(`users/${profile.id}`, "PUT", {
          body: profile,
          headers: { "Content-Type": "application/json" },
        })
          .then((response) => {
            if (response.status == 200) {
              setProfile(profile);
            }
          })
          .catch(function (error) {
            Sentry.captureException(error);
            console.log(error);
          });
      }
    } else {
      if (amount) {
        setAmountToProcess(amount);
      }
      setProceedtoPayment(true);
    }
  };

  return (
    <MDBox>
      <FormLabel sx={{ display: "block", marginBottom: "10px", fontSize: "20px" }}>
        {t("formLabels.haveReferral")}
      </FormLabel>
      <TextField
        name="coupon"
        placeholder={t("formPlaceHolders.haveReferral")}
        type="text"
        value={referralCode}
        onChange={(e) => {
          if (e.nativeEvent.data != " ") {
            setReferralCode(e.target.value.trim());
          }
        }}
        fullWidth
        required
        sx={{ marginBottom: "10px" }}
      />
      {showHelperText && (
        <MDTypography variant="h6" mb={1}>
          {helperText}
        </MDTypography>
      )}

      <Grid container justifyContent="center" alignItems="center" direction={"column"}>
        <Grid Item marginTop={"30px"}>
          {codeApplied ? (
            <MDButton style={{ width: "200px" }} onClick={RemoveCouponHandler} color="error">
              {t("buttonTitles.removeReferralCode")}
            </MDButton>
          ) : (
            <MDButton
              style={{ width: "200px" }}
              onClick={() => verifyCouponHandler(referralCode)}
              color="primary"
              disabled={referralCode.length < 1 || isLoading}
            >
              {isLoading ? (
                <CircularProgress color="white" size={20} />
              ) : (
                t("buttonTitles.applyReferralCode")
              )}
            </MDButton>
          )}
        </Grid>
        <Grid Item marginTop={"20px"} marginBottom={"20px"}>
          <MDButton
            style={{ width: "200px" }}
            onClick={proceedToPaymentHandler}
            color="primary"
            disabled={isLoading}
            fullWidth
          >
            {paymentNotRequired || demoUser
              ? t("buttonTitles.proceedToFinish")
              : t("buttonTitles.proceedToPayment")}
          </MDButton>
        </Grid>
      </Grid>
    </MDBox>
  );
}
